/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1052
 */

module.exports = {
  shareBtn: "style_shareBtn__2X5i-",
  shareIcon: "style_shareIcon__edD64",
  shareMessage: "style_shareMessage__3hXpU"
}
